import React from 'react';
import { ErrorBoundaryPolite } from './ErrorBoundaryPolite';
import { ErrorBoundaryRude } from './ErrorBoundaryRude';

export interface ErrorBoundaryGracefulProps {}

/**
 * ErrorBoundaryDefault is meant to handle events that happen once in a while
 * politely and to handle continuing errors rudely. See ErrorBoundaryPolite
 * (first attempt to render) and ErrorBoundaryRude (second attempt to render)
 * for more details.
 */
export const ErrorBoundaryDefault: React.FC<ErrorBoundaryGracefulProps> = props => {
  return (
    <ErrorBoundaryRude>
      <ErrorBoundaryPolite>{props.children}</ErrorBoundaryPolite>
    </ErrorBoundaryRude>
  );
};
